export const MapMasterdataBreadcrumb: Record<string, string> = {
  "1": "Combustion",
  "2": "Flare",
  "3": "Transportation & marketing",
  "4": "Fugitive",
  "5": "Tank",
  "6": "Waste water treatment",
};
// export const MapMasterdataBreadcrumb = {
//   COMBUSTION: "1",
//   FLARE: "2",
//   TERMINAL_AND_MARKETING: "3",
//   FUGITIVE: "4",
//   TANK: "5",
//   WASTE_WATER_TREATMENT: "6",
// };
